class OptionSwitchController {
  constructor(EventEmitter, $scope) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.scope = $scope;
  }

  $onInit() {
    this._initOptions();
    this._setInitialModeAndLock();
    this._setWatchSelectedOption();
  }

  _initOptions() {
    this.options = [];
  }

  _setInitialModeAndLock() {
    const initOption = this.lockOn ? this.lockOn : this.optionsData[0].value;
    this.options[initOption] = true;
    this._returnDefaultOption(initOption);
  }

  _returnDefaultOption(initOption) {
    if(this.autoReturnDefaultOption === true) {
      this._emitOption(initOption);
    }
  }

  _setWatchSelectedOption() {
    if (this.selectedOption) {
      this.scope.$watch(() => this.selectedOption, (selection) => {
        this._setOptionsStatus(selection);
      });
    }
  }

  selectOption(selection) {
    if (this._avoidDispatch()) {
      return;
    }

    this._setOptionsStatus(selection);
    this._emitOption(selection);
  }

  _avoidDispatch() {
    return this.lockOn && !this.editable;
  }

  _setOptionsStatus(selection) {
    this.options[selection] = true;

    Object.keys(this.options).forEach((option) => {
      if(selection !== option){
        this.options[option] = false;
      }
    });
  }

  _emitOption(selection) {
    this.onSelect(this.EventEmitter({option: selection}));
  }

  getCssActive(selected,last) {
    return {
      'active': this.options[selected],
      'shadow-on-left': last
    };
  }

  getClasses() {
    return {
      locked: (!!this.lockOn && !this.editable)
    };
  }
}

export default OptionSwitchController;



// WEBPACK FOOTER //
// ./client/app/components/optionSwitch/optionSwitch.controller.js